import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

/** The fields a template picker outside the QC page needs (Deliveries' intake
 *  picker, the delivery's QC card). The read is `select('*')`, so QC.tsx types
 *  the same cached rows with its full QcTemplate. */
export interface QcPickableTemplate {
  template_id:  string
  code:         string
  name:         string
  variety:      string | null
  commodity_id: string | null
}

// Active templates, picker-shaped — ALSO feeds the Checks-tab visibility in
// QCPage, so the template editor must invalidate this key alongside
// qc-templates-all or a newly created first custom template won't surface
// until a reload.
export function useQcPickableTemplates<T extends QcPickableTemplate = QcPickableTemplate>(opts?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['qc-templates-pickable'],
    enabled: opts?.enabled ?? true,
    queryFn: async () => {
      const { data, error } = await supabase.from('qc_templates')
        .select('*').is('deleted_at', null).eq('is_active', true)
        .order('display_order', { ascending: true })
        .order('name',          { ascending: true })
      if (error) throw error
      return data as unknown as T[]
    },
  })
}
